import { Component, OnInit, Input } from "@angular/core";
import { LowerCasePipe, NgClass } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";
import { GenericListConfigMultiLevel } from "@app/shared/models/GenericList/GenericListMultiLevel";
import { GenericListManagerComponent } from "@app/shared/generic-managers/generic-list-manager/generic-list-manager.component";
import { WorkspaceCellRendererComponent } from "@app/shared/workspace/workspace-cell-renderer/workspace-cell-renderer.component";

@Component({
    selector: "cerrix-table-multi-level",
    templateUrl: "./cerrix-table-multi-level.component.html",
    styleUrls: ["./cerrix-table-multi-level.component.scss"],
    imports: [LowerCasePipe, NgClass, MatTooltipModule, WorkspaceCellRendererComponent, CerrixTableMultiLevelComponent],
})
export class CerrixTableMultiLevelComponent extends GenericListManagerComponent implements OnInit {
    @Input()
    config: GenericListConfigMultiLevel;
    activeRow: any;

    ngOnInit(): void {
        super.ngOnInit();
    }

    triggerClick(row: any) {
        this.activeRow = row;
    }

    setScopedTable() {
        super.setScopedTable();
        this.scopedTableData.forEach((d) => (d.showEditor = this.config.showAll));
    }

    getLinkedIds(row) {
        this.scopedTableData.filter((a) => a !== row).forEach((x) => (x.showEditor = false));
    }

    setupInnerconfig(rowData) {
        const copy = { ...this.config.innerConfig };
        const data = rowData[this.config.innerListProp];

        if (!data) {
            return null;
        }

        copy.data = data;
        return copy;
    }
}